const mutations = {
  SET_LOGIN_INFO (state, val) {
    state.loginInfo = val
  },
  SET_LOGIN_URL (state, url) {
    state.domainLoginUrl = url
  },
  CHANGE_LOADING (state, val) {
    state.loading = val
  },
  SET_PAGE_HEIGHT (state, val) {
    state.pageHeight = val
  }
}

export default mutations
